import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXForm implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxFormContainer";
    }
    render(){
        // console.log("form");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxInquiryContainer", "firstName", "local_lead_first_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxInquiryContainer", "lastName", "local_lead_last_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxInquiryContainer", "phone", "local_lead_phone");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxInquiryContainer", "email", "local_lead_email");
    }
}